export default "https://legacy.eskolare.com/images/find-institutions.png";